/* Progressive enhancement: without this script, every completed tile stays visible. */
(function () {
  'use strict';
  if (window.serlexCategoryTiles) { window.serlexCategoryTiles.init(document); return; }
  var instances = new Map();
  function roots(scope) {
    var found = Array.from(scope.querySelectorAll('[data-serlex-categories]'));
    if (scope.matches && scope.matches('[data-serlex-categories]')) found.unshift(scope);
    return found;
  }
  function mount(root) {
    if (instances.has(root)) return;
    var cards = Array.from(root.querySelectorAll('.serlex-category-grid > .serlex-category-card'));
    var controls = root.querySelector('[data-serlex-category-controls]');
    var button = root.querySelector('[data-serlex-category-toggle]');
    var editor = root.dataset.editor === 'true' || !!(window.Shopify && window.Shopify.designMode);
    var initial = Math.max(4, Math.min(48, Number(root.dataset.initialVisible) || 20));
    if (!controls || !button || editor || root.dataset.showMore !== 'true' || cards.length <= initial) return;
    var label = button.querySelector('[data-serlex-category-label]');
    var count = root.querySelector('[data-serlex-category-count]');
    var expanded = false;
    function update() {
      cards.forEach(function (card, index) { card.hidden = !expanded && index >= initial; });
      button.setAttribute('aria-expanded', String(expanded));
      label.textContent = expanded ? button.dataset.lessLabel : button.dataset.moreLabel;
      count.textContent = 'Showing ' + (expanded ? cards.length : initial) + ' of ' + cards.length + ' categories';
    }
    function keepInView(element) {
      var bounds = element.getBoundingClientRect();
      if (bounds.top < 0 || bounds.bottom > window.innerHeight) {
        element.scrollIntoView({block: 'nearest', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
    }
    function toggle() {
      expanded = !expanded;
      update();
      if (expanded) {
        cards[initial].focus({preventScroll: true});
        keepInView(cards[initial]);
      } else {
        button.focus({preventScroll: true});
        keepInView(button);
      }
    }
    update();
    controls.hidden = false;
    button.addEventListener('click', toggle);
    instances.set(root, function () {
      button.removeEventListener('click', toggle);
      cards.forEach(function (card) { card.hidden = false; });
      controls.hidden = true;
      instances.delete(root);
    });
  }
  function init(scope) { roots(scope).forEach(mount); }
  window.serlexCategoryTiles = {init: init};
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    roots(event.target).forEach(function (root) { var destroy = instances.get(root); if (destroy) destroy(); });
  });
}());
